// extracted by mini-css-extract-plugin
export default {"container":"formSeparator_container__4kSxs","separator":"formSeparator_separator__LJ9HZ"};